import './instruments';
import './index.css';
import './locales/i18n';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Inject development proxy token from env into localStorage (frontend .env must prefix with REACT_APP_)
try {
  const devProxyToken = (process.env.REACT_APP_API_AUTH_TOKEN || '').trim();
  if (devProxyToken && typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem('API_AUTH_TOKEN', devProxyToken);
  }
} catch {}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
document.title = 'Cortex by BID Equity';
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
